import gql from 'graphql-tag'
export default gql`mutation deleteSieveSetMutation($sieveSetId: Int!) {
  deleteSieveSet(sieveSetId: $sieveSetId) {
    success
  }
}`